// extracted by mini-css-extract-plugin
module.exports = {"root":"confirm_root__PPpGb","title":"confirm_title__HzxHF","description":"confirm_description__Zz8dO"};